export default __webpack_public_path__ + "static/media/wowIcon.6ba27b5c.png";